import React, { forwardRef, useImperativeHandle, useRef, useState, useCallback } from 'react';
import { SessionV2, SessionActivity } from '../../../api/sessionsV2Api';
import MultipleSessionsPaymentBottomSheet from './MultipleSessionsPaymentBottomSheet';

export interface PaymentSheetHostHandle {
  open: (sessions: SessionV2[]) => void;
}

interface PaymentSheetHostProps {
  siteId: number;
  typeOfWorkId?: number;
  isAdditionalWork?: boolean;
  preloadedActivities: Record<number, SessionActivity[]>;
  onClose: () => void;
  onSuccess: () => void;
}

/**
 * Обёртка для мгновенного открытия окна оплаты без тяжёлого ре-рендера родителя.
 * Открытие через ref.open() вызывает ре-рендер только этого компонента.
 */
const PaymentSheetHost = forwardRef<PaymentSheetHostHandle, PaymentSheetHostProps>((props, ref) => {
  const {
    siteId,
    typeOfWorkId,
    isAdditionalWork,
    preloadedActivities,
    onClose: parentOnClose,
    onSuccess: parentOnSuccess
  } = props;

  const [isOpen, setIsOpen] = useState(false);
  const [sessions, setSessions] = useState<SessionV2[]>([]);

  const handleClose = useCallback(() => {
    setIsOpen(false);
    setSessions([]);
    parentOnClose();
  }, [parentOnClose]);

  const handleSuccess = useCallback(() => {
    setIsOpen(false);
    setSessions([]);
    parentOnSuccess();
  }, [parentOnSuccess]);

  useImperativeHandle(ref, () => ({
    open: (sessionsToPay: SessionV2[]) => {
      setSessions(sessionsToPay);
      setIsOpen(true);
    }
  }), []);

  return (
    <MultipleSessionsPaymentBottomSheet
      isOpen={isOpen}
      sessions={sessions}
      siteId={siteId}
      onClose={handleClose}
      onSuccess={handleSuccess}
      typeOfWorkId={typeOfWorkId}
      isAdditionalWork={isAdditionalWork}
      preloadedActivities={preloadedActivities}
    />
  );
});

PaymentSheetHost.displayName = 'PaymentSheetHost';

export default PaymentSheetHost;
